import * as React from 'react';
import { LockIcon } from '@patternfly/react-icons';
import {
  Button,
  EmptyState,
  EmptyStateBody,
  EmptyStateFooter,
  PageSection,
} from '@patternfly/react-core';
import { UserButton } from '@clerk/clerk-react';

const AccessDenied = (): React.ReactElement => (
  <PageSection hasBodyWrapper={false} isFilled>
    <EmptyState titleText="Access denied" variant="full" icon={LockIcon}>
      <EmptyStateBody>
        Your account does not have admin access to the dashboard. Please contact an administrator.
      </EmptyStateBody>
      <EmptyStateFooter>
        <Button variant="primary" onClick={() => window.location.assign('/')}>Go home</Button>
        <div style={{ marginTop: '12px' }}>
          <UserButton afterSignOutUrl="/sign-in" />
        </div>
      </EmptyStateFooter>
    </EmptyState>
  </PageSection>
);

export default AccessDenied;
